import { useSelector, useDispatch } from 'react-redux'
import { ArrowLeftIcon, IconButton } from '@buffer-mono/popcorn'
import type { IconButtonProps } from '@buffer-mono/popcorn'

import { setShowChannelStorefront } from '../../../../../../store/channelConnectionsReducer'
import type { OrchestratorRootState } from '../../../../../../../../common/events/types'

import type { JSX } from 'react'

type BackButtonProps = {
  onBack?: () => void
  size?: IconButtonProps['size']
  variant?: IconButtonProps['variant']
  className?: IconButtonProps['className']
}

export function BackButton({
  onBack,
  className,
  size,
  variant,
}: BackButtonProps): JSX.Element {
  const dispatch = useDispatch()
  const { cta } = useSelector(
    (state: OrchestratorRootState) => state.channelConnections,
  )

  const handleClick = (): void => {
    if (!onBack) {
      dispatch(setShowChannelStorefront({ cta }))
      return
    }

    onBack()
  }

  const label = onBack ? 'Back' : 'Back to channel storefront'

  return (
    <IconButton
      onClick={handleClick}
      label={label}
      variant={variant || 'tertiary'}
      size={size || 'small'}
      className={className}
    >
      <ArrowLeftIcon />
    </IconButton>
  )
}
